/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CodexHookPayload,
  CodexHookPayload$Outbound,
  CodexHookPayload$outboundSchema,
} from "../components/codexhookpayload.js";

export type HooksNumberCodexSecurityOption1 = {
  deviceAgentTokenHeaderAuthorization: string;
  projectSlugHeaderGramProject: string;
};

export type HooksNumberCodexSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type HooksNumberCodexSecurity = {
  option1?: HooksNumberCodexSecurityOption1 | undefined;
  option2?: HooksNumberCodexSecurityOption2 | undefined;
};

export type HooksNumberCodexRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Optional endpoint hostname supplied by the Speakeasy hook plugin.
   */
  xGramHookHostname?: string | undefined;
  /**
   * Optional per-invocation token reused across retries so the server stores a redelivered event exactly once.
   */
  idempotencyKey?: string | undefined;
  codexHookPayload: CodexHookPayload;
};

/** @internal */
export type HooksNumberCodexSecurityOption1$Outbound = {
  device_agent_token_header_Authorization: string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const HooksNumberCodexSecurityOption1$outboundSchema: z.ZodMiniType<
  HooksNumberCodexSecurityOption1$Outbound,
  HooksNumberCodexSecurityOption1
> = z.pipe(
  z.object({
    deviceAgentTokenHeaderAuthorization: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      deviceAgentTokenHeaderAuthorization:
        "device_agent_token_header_Authorization",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function hooksNumberCodexSecurityOption1ToJSON(
  hooksNumberCodexSecurityOption1: HooksNumberCodexSecurityOption1,
): string {
  return JSON.stringify(
    HooksNumberCodexSecurityOption1$outboundSchema.parse(
      hooksNumberCodexSecurityOption1,
    ),
  );
}

/** @internal */
export type HooksNumberCodexSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const HooksNumberCodexSecurityOption2$outboundSchema: z.ZodMiniType<
  HooksNumberCodexSecurityOption2$Outbound,
  HooksNumberCodexSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function hooksNumberCodexSecurityOption2ToJSON(
  hooksNumberCodexSecurityOption2: HooksNumberCodexSecurityOption2,
): string {
  return JSON.stringify(
    HooksNumberCodexSecurityOption2$outboundSchema.parse(
      hooksNumberCodexSecurityOption2,
    ),
  );
}

/** @internal */
export type HooksNumberCodexSecurity$Outbound = {
  Option1?: HooksNumberCodexSecurityOption1$Outbound | undefined;
  Option2?: HooksNumberCodexSecurityOption2$Outbound | undefined;
};

/** @internal */
export const HooksNumberCodexSecurity$outboundSchema: z.ZodMiniType<
  HooksNumberCodexSecurity$Outbound,
  HooksNumberCodexSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => HooksNumberCodexSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => HooksNumberCodexSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function hooksNumberCodexSecurityToJSON(
  hooksNumberCodexSecurity: HooksNumberCodexSecurity,
): string {
  return JSON.stringify(
    HooksNumberCodexSecurity$outboundSchema.parse(hooksNumberCodexSecurity),
  );
}

/** @internal */
export type HooksNumberCodexRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "X-Gram-Hook-Hostname"?: string | undefined;
  "Idempotency-Key"?: string | undefined;
  CodexHookPayload: CodexHookPayload$Outbound;
};

/** @internal */
export const HooksNumberCodexRequest$outboundSchema: z.ZodMiniType<
  HooksNumberCodexRequest$Outbound,
  HooksNumberCodexRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    xGramHookHostname: z.optional(z.string()),
    idempotencyKey: z.optional(z.string()),
    codexHookPayload: CodexHookPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      xGramHookHostname: "X-Gram-Hook-Hostname",
      idempotencyKey: "Idempotency-Key",
      codexHookPayload: "CodexHookPayload",
    });
  }),
);

export function hooksNumberCodexRequestToJSON(
  hooksNumberCodexRequest: HooksNumberCodexRequest,
): string {
  return JSON.stringify(
    HooksNumberCodexRequest$outboundSchema.parse(hooksNumberCodexRequest),
  );
}
